module.exports = __webpack_public_path__ + "static/media/webdesign-services-img27.a339fc7e.jpg";